<template>
<div class="chapter">
<div class="inner_page">
<div class="body">
<blockquote epub:type="epigraph" role="doc-epigraph">
<p class="sp"> </p>
<p class="FMEP"><span aria-label="v" id="pg_v" role="doc-pagebreak"><i>Look, I am living</i></span></p>
<p class="FMEP"><i>—on what?</i></p>
<p class="FMEPC"><b>—RAINER MARIA RILKE</b>, <i>Duino Elegies</i></p>
<p class="FMEP"><i>I continue to write because I have not yet heard what I have been listening to.</i></p>
<p class="FMEPC"><b>—MARY RUEFLE</b></p>
</blockquote>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// epigraph.vue?687e16fe